<template>
  <fieldset>
    <div class="form-wrap">

      <div>
        <label for="name">Company Name</label>
        <input type="text" id="name" v-model="$parent.agent.name">
      </div>

      <div>
        <label for="abta">ABTA Number</label>
        <input id="abta" type="text" v-model="$parent.agent.abta">
      </div>

      <div>
        <label for="email">Email Address</label>
        <input id="email" type="email" v-model="$parent.agent.email">
      </div>

      <div>
        <label for="phone_number">Phone Number</label>
        <input type="text" id="phone_number" v-model="$parent.agent.phone_number">
      </div>

      <div>
        <label for="address_line_1">Address Line 1</label>
        <input type="text" id="address_line_1" v-model="$parent.agent.address_line_1">
      </div>

      <div>
        <label for="address_line_2">Address Line 2</label>
        <input type="text" id="address_line_2" v-model="$parent.agent.address_line_2">
      </div>

      <div>
        <label for="town_city">Town/City</label>
        <input type="text" id="town_city" v-model="$parent.agent.town_city">
      </div>

      <div>
        <label for="county">County</label>
        <input type="text" id="county" v-model="$parent.agent.county">
      </div>

      <div>
        <label for="postcode">Postcode</label>
        <input type="text" id="postcode" v-model="$parent.agent.postcode">
      </div>

    </div>

    <div class="form-wrap">

      <div>
        <label for="commission">Commission (%)</label>
        <input type="number" id="commission" v-model="$parent.agent.commission">
      </div>

      <div>
        <label for="credit_limit">Credit Limit (£)</label>
        <input type="number" id="credit_limit" v-model="$parent.agent.credit_limit">
      </div>

      <div>
        <label for="login_password">
          Password for Login
          <span class="badge badge-success" v-if="$parent.agent.is_password_generated">Exists</span>
        </label>
        <input type="text" id="login_password" placeholder="Password for Login" v-model="$parent.agent.password">
      </div>

    </div>
  </fieldset>
</template>

<script>
export default {
  name: 'AgentFields',
  data () {
    return {
      loading: false
    }
  }
}
</script>
